var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('projects-table',{attrs:{"projects":_vm.projects,"simplify":"","title-bar":""}},[_c('create-project',{attrs:{"client":_vm.client}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }